<template>
    <app-page-options-list :options="options" />
</template>
<script>
    import PageOptionsList from '../../UI/Controls/PageOptions/PageOptionsList.vue';
    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
        data(){
            return {
                options: [
                    { to: 'vigilancePage', label: 'Ingresos' },
                    { to: 'departuresPage', label: 'Salidas' },
                     { to: 'peoplePageListVigilance', label: 'Personas' },
                    { to: 'vehiclesPageVigilance', label: 'Vehiculos'},
                    { to: 'notebook', label: 'Minutas' },
                    { to: 'mail', label: 'Correspondencia' },
                    { to: 'supervisionIndexPage', label: 'Supervisión' },
                    { to: 'authorizeEntryPersonList', label: 'Autorizaciones' },
                    { to: 'dutiesListVigilance', label: 'Consignas'}
                ]
            }
        }
    }
</script>